export interface ApiResponse<T> {
  data: T;
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export interface ApiErrorBody {
  error: {
    code: string;
    message: string;
    details?: Record<string, string[]>;
  };
}

/**
 * The frontend's one sentence for a failure that is not a server refusal (a
 * network error, an answer that is not JSON, a fault in the screen's own
 * code). The browser's or the parser's own text is never shown in its place.
 */
export const UNEXPECTED_ERROR_MESSAGE = "An unexpected error occurred";

export class ApiClientError extends Error {
  status: number;
  code: string;
  details?: Record<string, string[]>;

  constructor(status: number, code: string, message: string, details?: Record<string, string[]>) {
    super(message);
    this.name = "ApiClientError";
    this.status = status;
    this.code = code;
    this.details = details;
  }
}
